import { z } from "zod";
import { ComponentRoleSchema } from "./component-role.js";
/** Typed layout component selection (replaces z.record(z.unknown())). */
export const ComponentSelectionSchema = z
    .object({
    sectionId: z.string().min(1),
    componentId: z.string().min(1),
    componentVersion: z.string().min(1).optional(),
    role: z.union([ComponentRoleSchema, z.string().min(1)]).optional(),
    packComponentKey: z.string().min(1).optional(),
    selectionSource: z
        .enum(["BUSINESSGRAPH_LOCK", "INTENT_PLANNER", "REFERENCE", "FALLBACK"])
        .optional(),
    locked: z.boolean().optional(),
    decisionId: z.string().min(1).optional(),
})
    .strict();
export const ComponentSelectionListSchema = z.array(ComponentSelectionSchema);
//# sourceMappingURL=component-selection.js.map